module.exports = __webpack_public_path__ + "static/media/ybor-slide-05.fe1f9dde.png";